<template>
  <main class="main main--not-found main--full-height">
    <div class="group group--narrower group--last">
      <h1 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1">We’re sorry, but the page you have tried to access does not exist.</h1>

      <module-button
        link="home"
        label="Return to the homepage"
      />
    </div>
  </main>
</template>

<script>

// Vuex
import { mapGetters } from 'vuex';

// Models
import meta from 'models/meta';

// Utils
import { createMeta } from 'utils/meta';

// Export
export default {
  name: 'view-not-found',


  computed: {
    ...mapGetters('app', ['org']),
  },

  // Meta data
  metaInfo: {
    title: meta.notFound.title,
    meta: createMeta(meta.notFound.meta),
  },
};
</script>



// WEBPACK FOOTER //
// 404.vue?1c1dafe9